import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import FadeIn from './FadeIn';

const Hero = () => {
  return (
    <section className="relative pt-24 pb-16 md:pt-32 md:pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-[color:var(--bg)] to-white overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <div className="space-y-6">
            <FadeIn delay={0}>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-tight text-[color:var(--text-primary)]">
                Konečně praktická AI<br />
                <span className="text-[color:var(--primary-500)]">pro české pedagogy</span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.1}>
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-[color:var(--border)] shadow-sm">
                <Sparkles className="w-4 h-4 text-[color:var(--primary-500)]" />
                <span className="text-sm text-[color:var(--text-secondary)] font-medium">Méně času nad dokumenty. Více času pro děti.</span>
              </div>
            </FadeIn>

            <FadeIn delay={0.2}>
              <div className="text-base md:text-lg text-[color:var(--text-secondary)] leading-relaxed max-w-xl space-y-4">
                <p>
                  Standardní AI nástroje ve škole nestačí. Neznají české školství. Nerozumí RVP 2025. Nepracují s vaším ŠVP ani školním řádem a míjejí realitu každodenní pedagogické práce.
                </p>
                <p>
                  Školobot je vyladěný pro české školství a dává pedagogům i vedení školy vše potřebné pro přípravu výuky, tvorbu materiálů, hodnocení žáků i administrativu. <strong className="text-[color:var(--text-primary)]">Dnes existuje přes 500 modelů AI — Školobot vybírá vždy ten nejlepší pro daný úkol.</strong> V jednom prostředí, na fakturu a za cenu, která dává smysl.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.3}>
              <div className="flex flex-col sm:flex-row gap-3 max-w-lg">
                <a href="/#webinar">
                  <Button className="h-12 px-7 bg-[color:var(--primary-500)] hover:bg-[color:var(--primary-600)] text-white font-semibold rounded-xl shadow-md hover:shadow-lg transition-all">
                    Webinář zdarma
                    <ArrowRight className="ml-2 w-4 h-4" />
                  </Button>
                </a>
                <a href="https://app.skolobot.cz/register" target="_blank" rel="noopener noreferrer">
                  <Button variant="outline" className="h-12 px-7 bg-white border-2 border-[color:var(--primary-500)] text-[color:var(--primary-600)] font-semibold rounded-xl hover:bg-[color:var(--primary-50)] transition-all">
                    Vyzkoušet zdarma
                  </Button>
                </a>
              </div>
            </FadeIn>

            <FadeIn delay={0.4}>
              <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-[color:var(--text-secondary)]">
                <div className="flex items-center gap-2">
                  <span className="text-green-600">✓</span>
                  <span>Na fakturu bez platební karty</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-green-600">✓</span>
                  <span>V souladu s GDPR</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-green-600">✓</span>
                  <span>Vaše školní data jsou v bezpečí</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-green-600">✓</span>
                  <span>Vše v češtině a na jednom místě</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-green-600">✓</span>
                  <span>Pro MŠ, ZŠ i SŠ</span>
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Right Column - Video */}
          <FadeIn delay={0.5}>
            <div className="relative hidden lg:block max-w-sm mx-auto">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl border-2 border-white">
                <div style={{ position: 'relative', paddingTop: '177.77%' }}>
                  <iframe
                    src="https://customer-gcuxez6n2j23rqqn.cloudflarestream.com/549268534930fda541689a4574262702/iframe?poster=https%3A%2F%2Fcustomer-gcuxez6n2j23rqqn.cloudflarestream.com%2F549268534930fda541689a4574262702%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D0s%26height%3D600&autoplay=true&loop=true&muted=true&controls=true"
                    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
                    allowFullScreen
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      border: 'none'
                    }}
                  />
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default Hero;